<div class="language-selector">
  <button
    #trigger
    type="button"
    class="language-trigger"
    [class.open]="isOpen()"
    [disabled]="availableLangs().length === 0"
    [attr.aria-expanded]="isOpen()"
    [attr.aria-controls]="menuId"
    [attr.aria-label]="'LANGUAGE.SELECT_LANGUAGE' | translate: { lang: currentLang().toUpperCase() }"
    (click)="toggleMenu()"
  >
    <span>{{ currentLang().toUpperCase() }}</span>
    @if (availableLangs().length > 0) {
      <svg class="language-chevron" aria-hidden="true" viewBox="0 0 16 16">
        <path d="m4 6 4 4 4-4" />
      </svg>
    }
  </button>

  @if (isOpen()) {
    <ul [id]="menuId" class="language-menu">
      @for (lang of availableLangs(); track lang) {
        <li>
          <button
            type="button"
            class="language-option"
            [attr.aria-label]="('LANGUAGE.SWITCH_TO_' + lang.toUpperCase()) | translate"
            (click)="selectLang(lang)"
          >
            {{ lang.toUpperCase() }}
          </button>
        </li>
      }
    </ul>
  }


</div>
